import React from 'react'
import { Tag, Tooltip, Typography } from 'antd'
import classNames from 'classnames'
import { ITableOrder } from 'models/orders'
import { getOrderDeadline } from 'shared/utils/orders/getOrderDeadline'
import styles from './OrderDeadline.module.scss'

interface IOrderDeadlineProps {
  order: ITableOrder
  className?: string
}

const HOUR_MS = 60 * 60 * 1000

const texts = {
  confirmation: { hint: 'Примите заказ вовремя', overdue: 'Подтверждение просрочено' },
  shipping: { hint: 'Отправьте заказ вовремя', overdue: 'Отправка просрочена' }
}

// Чем меньше времени осталось, тем тревожнее цвет
const getColor = (msLeft: number) => {
  if (msLeft >= 12 * HOUR_MS) return 'green'
  if (msLeft >= 6 * HOUR_MS) return 'orange'
  return 'red'
}

const formatCountdown = (msLeft: number) => {
  const seconds = Math.floor(msLeft / 1000)
  const pad = (value: number) => String(value).padStart(2, '0')

  return [
    pad(Math.floor(seconds / 3600)),
    pad(Math.floor(seconds / 60) % 60),
    pad(seconds % 60)
  ].join(':')
}

export const OrderDeadline: React.FC<IOrderDeadlineProps> = ({ order, className }) => {
  const [, setTick] = React.useState(0)

  const deadline = getOrderDeadline(order)
  const msLeft = deadline ? deadline.deadline.valueOf() - Date.now() : 0
  const isRunning = msLeft > 0

  // Таймер идёт по секундам, поэтому компонент перерисовывает себя сам
  React.useEffect(() => {
    if (!isRunning) return

    const timer = setInterval(() => setTick((value) => value + 1), 1000)
    return () => clearInterval(timer)
  }, [isRunning])

  if (!deadline) return null

  const { hint, overdue } = texts[deadline.kind]

  if (!isRunning) {
    const hours = deadline.hoursLeft

    return (
      <Typography.Text className={classNames(styles.overdue, className)}>
        {hours > 0 ? `${overdue} на ${hours} ч` : overdue}
      </Typography.Text>
    )
  }

  return (
    <Tooltip title={hint}>
      <Tag color={getColor(msLeft)} className={classNames(styles.timer, className)}>
        {formatCountdown(msLeft)}
      </Tag>
    </Tooltip>
  )
}
